export default [
  {
    path: '/report/student-lists',
    name: 'report-student-list',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/student-list.vue')
  },

  {
    path: '/report/student-semester-exam-lists',
    name: 'report-studnet-semester-exam-list',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/academic/studnet-semester-exam-list.vue')
  },
  {
    path: '/report/student-list-for-moeys',
    name: 'report-student-list-for-moeys',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/academic/student-list-for-moeys.vue')
  },
  {
    path: '/report/info-inquiries',
    name: 'report-info-inquiry',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/info-inquiry.vue')
  },
  {
    path: '/report/student-transfers',
    name: 'report-student-transfer',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/student-transfer.vue')
  },
  {
    path: '/report/student-enrollments',
    name: 'report-student-enrollment',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/student-enrollment.vue')
  },
  {
    path: '/report/transportation-lists',
    name: 'report-transportation-list',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/transportation-list.vue')
  },
  {
    path: '/report/inactive-students',
    name: 'report-inactive-student',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/inactive-student.vue')
  },
  {
    path: '/report/student-exchanges',
    name: 'report-student-exchange',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/student-exchange.vue')
  },
  {
    path: '/report/foundation-years',
    name: 'report-foundation-year',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/foundation-year.vue')
  },
  {
    path: '/report/confirmations',
    name: 'report-confirmation',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/confirmation.vue')
  },
  {
    path: '/report/transcripts',
    name: 'report-transcript',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/transcript.vue')
  },
  {
    path: '/report/provisionals',
    name: 'report-provisional',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/provisional.vue')
  },
  {
    path: '/report/final-results',
    name: 'report-final-result',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/final-result.vue')
  },
  {
    path: '/report/score-lists',
    name: 'report-score-list',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/score-list.vue')
  },
  {
    path: '/report/student-exam-list-for-meoys',
    name: 'report-student-exam-list-for-meoy',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/academic/student-exam-list-for-meoy.vue')
  },
  {
    path: '/report/report-cards',
    name: 'report-card',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/report-card.vue')
  },
  {
    path: '/report/report-class-attendances',
    name: 'report/report-class-attendance',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/class-attendance.vue')
  },
  {
    path: '/report/report-student-class-attendances',
    name: 'report/report-student-class-attendance',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/academic/student-class-attendance.vue')
  },
  {
    path: '/report/report-attendance-by-students',
    name: 'report/report-attendance-by-student',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/attendance-by-student.vue')
  },
  {
    path: '/report/inquiry-follow-ups',
    name: 'report-inquiry-follow-up',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/inquiry-follow-up.vue')
  },
  {
    path: '/report/report-scorings',
    name: 'report-report-scoring',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/report-scoring.vue')
  },
  {
    path: '/report/score-result-list-khmers',
    name: 'score-result-list-khmer',
    meta: { requiresAuth: true },
    component: () =>
      import(
        '@/pages/report/academic/student-score/score-result-list-khmer.vue'
      )
  },
  {
    path: '/report/score-result-list-englishs',
    name: 'score-result-list-english',
    meta: { requiresAuth: true },
    component: () =>
      import(
        '@/pages/report/academic/student-score/score-result-list-english.vue'
      )
  },
  {
    path: '/report/report-card-khmers',
    name: 'report-card-khmer',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/academic/student-score/report-card-khmer.vue')
  },
  {
    path: '/report/report-card-englishs',
    name: 'report-card-english',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/academic/student-score/report-card-english.vue')
  },
  {
    path: '/report/academic-reports',
    name: 'academic-report',
    component: () => import('@/pages/report/academic/academic-report.vue')
  },
  {
    path: '/report/thesis-rigistrations',
    name: 'thesis-rigistration',
    component: () => import('@/pages/report/academic/thesis-rigistration.vue')
  },
  {
    path: '/report/re-exam-and-re-learns',
    name: 're-exam-and-re-learn',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/re-exam-and-re-learn.vue')
  },
]
